import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import AppShell from './app-shell/AppShell';
import IdentityProviderCreate from './identity-providers/IdentityProviderCreate';
import IdentityProviderEdit from './identity-providers/IdentityProviderEdit';
import NotFound from './not-found/NotFound';
import { appRoutes } from './routes';
import { initializeAuthlib, checkAndRestoreSession } from './authentication/authUtils';

import './index.css';

import '@boomi/exosphere/dist/icon.js';

initializeAuthlib();

const isAuthenticated = await checkAndRestoreSession();

if (isAuthenticated) {
    ReactDOM.createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <BrowserRouter>
                <Routes>
                    <Route element={<AppShell />}>
                        <Route index element={<Navigate to="/home" replace />} />
                        {appRoutes.map(({ path, element }) => (
                            <Route key={path} path={path} element={element} />
                        ))}
                        <Route path="identity-providers/new" element={<IdentityProviderCreate />} />
                        <Route path="identity-providers/:id" element={<IdentityProviderEdit />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </StrictMode>,
    );
}
